import Vue from 'vue';
import VueRouter from 'vue-router';
import CourseLessonNav from './vue-components/course-lesson-nav.vue';
import App from './vue-components/app.vue';
import CourseTile from './vue-components/course-tile.vue';
import LessonTile from './vue-components/lesson-tile.vue';
import LevelDrill from './vue-components/level-drill.vue';
import numFormat from 'vue-filter-number-format';


// Vue.config.devtools = true;


export default function mountHomeNav(el) {

	Vue.use(VueRouter);
	Vue.component('course-tile', CourseTile);
	Vue.component('lesson-tile', LessonTile);
	Vue.component('level-drill', LevelDrill);
	Vue.filter('numFormat', numFormat);

	let router = new VueRouter({
		routes: [
			{name:'courseLessonNav', path:'/:courseId?/:lessonId?/:skipped?', component:CourseLessonNav},
		],
	});

	let nav = new Vue({
		el,
		router,
		render: h => h(App),
	});
}
